import { render, staticRenderFns } from "./InfoMacchina.vue?vue&type=template&id=73c9bc06&scoped=true"
import script from "./InfoMacchina.vue?vue&type=script&lang=js"
export * from "./InfoMacchina.vue?vue&type=script&lang=js"
import style0 from "./InfoMacchina.vue?vue&type=style&index=0&id=73c9bc06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c9bc06",
  null
  
)

export default component.exports